import React, {Component,PropTypes} from 'react'

class Toggle extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value:props.value,
    };
    this.handleChange=this.handleChange.bind(this);
   
  }

  handleChange(event) {

    var value_update = true;

    console.log(event.target.value);

// XAVI MODIFICAR VALOR DEL UPDATE PER REFRESAR Bé L'ESTATUS

    if (event.target.value == "true") {

      value_update = "false";
    }
    if (event.target.value == "false") {

      value_update = "true";

    }

    console.log("el valor del update es ", value_update);


    this.setState({value: value_update});

    this.props.updateAction(this.props.theKey,value_update);
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

 
  render() {

    console.log("el valor del checkbox es ", this.state.value);
    

      

        return (
            <div className="form-group label-floating is-empty">
             
              <div className="togglebutton" >
                <label>
                 <input type="checkbox" name={this.props.theKey} value={this.state.value} checked={this.state.value === "true"} onChange={this.handleChange} />
                 <span className="toggle" ></span> {this.capitalizeFirstLetter("activado")}
                </label>
               </div>
            </div>
      )


  } 
}
export default Toggle;

Toggle.propTypes = {
    updateAction:PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    theKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/fields/Toggle.js